import React, {Component} from "react";
import './list-tab.component.css';



export class ListTabButton extends Component {
    constructor(props) {
        super(props);
        this.state={
            selected:0,
        }
    }

    onSelect = (e, disabled) => {
        if (!disabled) {
            this.props.FilterIndex(e.target.attributes.getNamedItem('data-index').value)
            {
                this.props.filterList &&
                this.props.filterList(e.target.innerText)
            }
        }
    }

    render(){     
        return(
           <div  className="list-tab-button-contaner">            
                {this.props.listData.map((list, index) =>
                    !list.hidden &&
                    <div key={list.id} data-index={index} className={`${list.disable ? "tab-disable" : ""} ${this.props.selectedIndex == list.id ? "isSelected" : ""} list-tab`} onClick={(e) => this.onSelect(e, list.disable)}>
                        <span data-index={index}>{list.label} </span>  
                    </div>
                    
                )}
           </div>
        )
    }
}